exports = module.exports = require("../../../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video{max-width:720px;min-height:180px;background:#ddd;margin:0 auto}.video,.video iframe{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f5c3a12","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/less-loader@4.1.0_less@2.7.3_webpack@3.12.0/node_modules/less-loader/dist/cjs.js!./resources/assets/front/js/components/jj-video/style.less
// module id = 195
// module chunks = 14